const body = document.querySelector('body');

const rave = () => {
	const top = Math.floor((Math.random() * 100) + 1);
	const left = Math.floor((Math.random() * 100) + 1);

	const width = Math.floor((Math.random() * 180) + 30);
	const height = width * 0.715;

	const newImg = new Image();
	newImg.src = 'http://s3.amazonaws.com/cratejoy-marketplace-images/b603ab1de3254a9a8cafe0e79e4c0aac.gif';
	newImg.style.position =  'absolute';
	newImg.style.top =  top + '%';
	newImg.style.left =  left + '%';
	newImg.style.width =  width + 'px';
	newImg.style.height =  height + 'px';
	newImg.style.zIndex =  '99999';

	body.appendChild(newImg);
};

const rad = () => {
	rave();
	setInterval(rave, 800);
};

// :sunglasses:
// https://en.wikipedia.org/wiki/Konami_Code
const keySeq = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
let curKey = 0;

const parrot = e => {
	if(e.which === keySeq[curKey]) {
		curKey++;
	} else {
		curKey = 0;
	}

	if(curKey === keySeq.length) {
		rad();
		curKey = 0;
	}
};

export const parrotListen = () => {
	window.addEventListener('keydown', parrot);
};

export const parrotUnlisten = () => {
	window.removeEventListener('keydown', parrot);
};
